import PropTypes from 'prop-types';

export const CRUMBS_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.node.isRequired,
    }),
);
